/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/information_bubble'
export default icon
